{
  "Accessibility Menu": "Meni dostopnosti",
  "Reset settings": "Ponastavi nastavitve",
  "Close": "Zapri",
  "Content Adjustments": "Prilagoditve vsebine",
  "Adjust Font Size": "Prilagodi velikost pisave",
  "Highlight Title": "Označi naslov",
  "Highlight Links": "Označi povezave",
  "Readable Font": "Bralna pisava",
  "Color Adjustments": "Prilagoditve barv",
  "Dark Contrast": "Temni kontrast",
  "Light Contrast": "Svetli kontrast",
  "High Contrast": "Visoki kontrast",
  "High Saturation": "Visoka nasičenost",
  "Low Saturation": "Nizka nasičenost",
  "Monochrome": "Monokromno",
  "Contrast": "Kontrast",
  "Invert Colors": "Obrni barve",
  "Tools": "Orodja",
  "Reading Guide": "Bralni vodnik",
  "Stop Animations": "Ustavi animacije",
  "Big Cursor": "Velik kazalec",
  "Increase Font Size": "Povečaj velikost pisave",
  "Decrease Font Size": "Zmanjšaj velikost pisave",
  "Letter Spacing": "Razmik med črkami",
  "Line Height": "Višina vrstice",
  "Font Weight": "Debelina pisave",
  "Dyslexia Font": "Pisava za disleksijo",
  "Language": "Jezik",
  "Open Accessibility Menu": "Odpri meni dostopnosti",
  "Widget Settings": "Nastavitve gradnika",
  "Widget Position": "Položaj gradnika",
  "Top Left": "Zgoraj levo",
  "Top Center": "Zgoraj na sredini",
  "Top Right": "Zgoraj desno",
  "Center Left": "Sredina levo",
  "Center Right": "Sredina desno",
  "Bottom Left": "Spodaj levo",
  "Bottom Center": "Spodaj na sredini",
  "Bottom Right": "Spodaj desno",
  "Screen Reader": "Bralnik zaslona",
  "Voice Navigation": "Glasovna navigacija",
  "Custom Color": "Barva po meri",
  "Change the site's colors": "Spremeni barve spletnega mesta",
  "Backgrounds": "Ozadja",
  "Headings": "Naslovi",
  "Contents": "Vsebina",
  "Reset colors": "Ponastavi barve",
  "Image Desaturation": "Desaturacija slike",
  "Search languages": "Išči jezike",
  "No languages found": "Ni najdenih jezikov",
  "Accessibility Profiles": "Profili dostopnosti",
  "Motor Impaired": "Gibalno ovirani",
  "Big cursor, voice navigation, and no animations.": "Velik kazalec, glasovna navigacija in brez animacij.",
  "Blind": "Slepi",
  "Screen reader helpers with higher contrast.": "Pomočniki za bralnik zaslona z višjim kontrastom.",
  "Color Blind": "Barvna slepota",
  "High contrast palette with desaturated media.": "Paleta z visokim kontrastom in manj nasičenimi mediji.",
  "Dyslexia": "Disleksija",
  "Friendly font, extra spacing, stronger weight.": "Prijazna pisava, več razmikov in debelejši prelom.",
  "Low vision": "Slabovidni",
  "Dark contrast and 130% magnification.": "Temen kontrast in povečava 130 %.",
  "Cognitive & Learning": "Kognitivno in učenje",
  "Highlights key sections and enables voice help.": "Poudari ključne odseke in omogoči glasovno pomoč.",
  "Seizure & Epileptic": "Napadi in epilepsija",
  "Stops animations and desaturates imagery.": "Ustavi animacije in zmanjša nasičenost slik.",
  "ADHD": "ADHD",
  "Reading guide, highlighted links, calmer palette.": "Vodič za branje, poudarjene povezave in mirnejša paleta.",
  "Widget Size": "Widget Size",
  "Default": "Default",
  "Medium": "Medium",
  "Small": "Small",
  "Color Blindness": "Color Blindness",
  "Protanopia": "Protanopia",
  "Deuteranopia": "Deuteranopia",
  "Tritanopia": "Tritanopia",
  "Achromatopsia": "Achromatopsia",
  "Simulates and assists users with color vision deficiencies.": "Simulates and assists users with color vision deficiencies."
}
